import React, { createContext, useContext, useState } from "react";
import PropTypes from "prop-types";

const CaseSidePanelContext = createContext();

export const panelNames = {
  INJURIES: "injuries",
  PHYSICAL_DAMAGE: "physicalDamage"
};

const initialState = {
  [panelNames.INJURIES]: false,
  [panelNames.PHYSICAL_DAMAGE]: false
};

// Mounted once above CasesRoutes' Switch, so this survives each case
// sub-page mounting its own SectionWrapper (and, with it, a fresh instance
// of these accordions) as the user navigates within a case.
export const useCaseSidePanel = name => {
  const { [name]: expanded, togglePanel } = useContext(CaseSidePanelContext);
  return [expanded, () => togglePanel(name)];
};

const CaseSidePanelProvider = ({ children }) => {
  const [expanded, setExpanded] = useState(initialState);

  const togglePanel = name =>
    setExpanded(prev => ({ ...prev, [name]: !prev[name] }));

  // `children` is passed straight through (not reconstructed here), so
  // React can skip re-rendering the routed subtree below on a toggle - only
  // this provider and whichever accordion is subscribed re-render.
  return (
    <CaseSidePanelContext.Provider value={{ ...expanded, togglePanel }}>
      {children}
    </CaseSidePanelContext.Provider>
  );
};

CaseSidePanelProvider.propTypes = {
  children: PropTypes.node.isRequired
};

export default CaseSidePanelProvider;
